var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.16357,
    y: 16.7617,
    width: 15.931,
    height: 1.99138,
    rx: 0.99569,
    transform: "rotate(-45 5.16357 16.7617)",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4282,
    y: 18.1698,
    width: 15.931,
    height: 1.99138,
    rx: 0.99569,
    transform: "rotate(-135 16.4282 18.1698)",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a9f687e6ed484e97d45a6b6c81e43e20.svg";
export { ForwardRef as ReactComponent };